/**
 * Get user session actions
 */
export const getSessionRequestAction = () => ({ type: 'getSessionRequest' })
export const getSessionSuccessAction = jwtToken => ({
  type: 'getSessionSuccess',
  payload: { token: jwtToken }
})
export const getSessionFailureAction = () => ({ type: 'getSessionFailure' })
